export const DEFAULT_HEADERS = new Headers({
  Accept: 'application/grpc-web+proto',
  'Content-Type': 'application/grpc-web+proto',
});
